import React, { useEffect, useState } from 'react';

const MonthPicker = ({ onMonthClick, selectedYear, onChange, selectedMonth }) => {


    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

    return (
        <div className="year-picker">
            <div className='flex justify-center px-3 mb-[36px]'>
                <div className='text-primary cursor-pointer' onClick={onChange}>{selectedYear}</div>
            </div>
            <div className='grid grid-cols-4 grid-rows-3 gap-2 w-[290px]'>
                {months.map((month) => (
                    <div 
                        key={month} 
                        value={month} 
                        onClick={onMonthClick}
                        data-testid={month}
                        className={`grid-item flex justify-center items-center p-2 cursor-pointer 
                            ${selectedMonth === month ? 'text-primary' : 'text-[#1f1f1f]'}`}>
                        {month}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MonthPicker;